import React from 'react';
import {
    useMediaQuery,
    Box,
    Card,
    ListItem
} from '@material-ui/core';
import { Link } from "react-router-dom";
import { useTranslate } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import colors from '../CustomizedUIs/Colors'
import {
    makeStyles, useTheme
} from '@material-ui/core/styles';
import ArrowRightButton from '../CustomizedUIs/ArrowRightButton';
const useStyles = makeStyles(theme => ({

    searchPaper: {
        padding: '5px 10px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
        width: '236px',
        boxShadow: 'none'
    },
    TitleCluster: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    Paper: {
        borderRadius: '10px',
        boxShadow: ' 0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: '#ffffff',
    },
    TextCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: '#fafefe',
        padding:'11px'
    },
    borderArrow:{
        borderRadius: '10px',
    }

}))

const Item = ({ data }) => {
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const translate = useTranslate()
    const classes = useStyles()
    const theme=useTheme()

    return (
        <Card style={{boxShadow:'0 3px 6px 0 rgba(27, 102, 157, 0.04)', width: '100%', borderRadius: '10px', margin: '1em 0' }}>

            <ListItem
                button
                component={Link}
                to={{
                    pathname: "/Entity/" + encodeURIComponent(data.name)
                }}>
                <Box width='100%' display="flex" p={2} borderRadius="16px" >
                    <Box my='auto' width="40%">
                    <Typography className={classes.TitleCluster}>  {data.name}</Typography>
                    </Box>
                    <Box width="100%" justifyContent='flex-end' display="flex" pr="2em">
                        {
                            isDesktop &&
                            (
                                <Box display='flex' >
                                    <Box
                                        display='flex'
                                        justifyContent='center'
                                        width={80}
                                        className={classes.borderCluster}
                                        p={1} 
                                        mr={1}>
                                        <Typography  className={classes.TextCluster}>
                                            {(data.groupCount + " " + translate(data.groupCount <= 1 ? `pos.dashboard.group` : `pos.dashboard.groups`)).toUpperCase()}
                                        </Typography>
                                    </Box>
                                    <Box
                                        display='flex'
                                        justifyContent='center'
                                        width={80}
                                        className={classes.borderCluster}
                                        p={1}  >
                                        <Typography className={classes.TextCluster}>
                                            {(data.clusters + " " + translate(data.clusters <= 1 ? `pos.dashboard.cluster` : `pos.dashboard.clusters`)).toUpperCase()}
                                        </Typography>
                                    </Box>
                                </Box>
                            )

                        }
                      
                        <Box display='flex' justifyContent='flex-end' ml={8}>
                             <ArrowRightButton color={theme.squareButon.content}/>
                        </Box>
                    </Box>

                </Box>
            </ListItem>

        </Card>
    )
}

const ListContainer = ({ data, filter }) => {

    return (
      <Box width="100%">
        {data.entities
          .filter(
            (value) =>
              value.name
                .replace(/ /g, "")
                .toUpperCase()
                .indexOf(filter.replace(/ /g, "").toUpperCase()) > -1
          )
          .map((row, index) => (
            <div key={index}>
              <Item data={row} />
            </div>
          ))}
      </Box>
    );

}

export default ListContainer
